import * as React from "react";

export const AlertIcon = (props) => (
  <svg width={38} height={38} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6 19c0-7.18 5.82-13 13-13s13 5.82 13 13-5.82 13-13 13S6 26.18 6 19Z"
      stroke="#D92D20"
      strokeWidth={2}
      opacity={0.3}
    />
    <path
      d="M1 19C1 9.059 9.059 1 19 1s18 8.059 18 18-8.059 18-18 18S1 28.941 1 19Z"
      stroke="#D92D20"
      strokeWidth={2}
      opacity={0.1}
    />
    <g clipPath="url(#a)">
      <path
        d="M19 15.667V19m0 3.333h.009M27.334 19a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0"
        stroke="#D92D20"
        strokeWidth={1.667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M9 9h20v20H9z" />
      </clipPath>
    </defs>
  </svg>
);
